import { get, post, put } from "../services/HttpService";
import { axiosIns } from "../services";
import { amountValidationRegex } from "../app_methods";

export class SmartCollectDisbursements {

    static validations = {
        id: [],
        uuid: [],
        amount: [
            { required: true, message: "Amount is required." },
            {
                pattern: amountValidationRegex(),
                message: "Please enter a valid amount.",
            },
        ],
    };

    static list = (queryData = {}, config = {}) => {
        return get(`v1/insta-collect/internal/disbursement_requests/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    static list_v2 = (queryData = {}, config = {}) => {
        return get(`v2/insta-collect/internal/disbursement_requests/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };


    static initiate_settlements = (queryData = {}, config = {}) => {
        return post(`v1/insta-collect/internal/settlements/initiate/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    static account_list = (queryData = {}, config = {}) => {
        return get(`v1/insta-collect/internal/settlements/accounts/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    static download_report = (queryData = {}, config = {}) => {
        return axiosIns.request({
            url: 'v1/insta-collect/internal/disbursement_requests/reports/',
            method: 'POST',
            responseType: 'blob',
            data: queryData,
            headers: config.headers
        }).catch(error => ({ success: false, data: "Something went wrong", status: 500 }))
    }

    static download_settlement_mapping_report = (params) => {
        return post(
            `v1/insta-collect/internal/settlements/settlement_mapping_report/`,
            params,
            {}
        ).catch(error => ({
            success: false,
            data: (error.response && error.response.data) || {},
            status: (error.response && error.response.status) || 400
        }));
    };

    static download_setlement_report = (id) => {
        return post(`v1/insta-collect/internal/settlements/${id}/report_download/`, {}, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof VirtualAccount
     * @type Getter Method
     * @takes void
     * @returns VirtualAccount Params
     */
     get = () => {
        return {
            id: this.id,
        };
    };

    /**
     * @memberof VirtualAccount
     * @type Setter Method
     * @takes VirtualAccount Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach((x) => (this[x] = values[x]));
    };

    /**
     * @memberof VirtualAccount
     * @type Setter Method
     * @takes VirtualAccount Params
     * @returns void
     */
    reset = () => {
        this.id = undefined;
    };
}